module.exports = __webpack_public_path__ + "img/charge-back.56a2f7a5.png";